module.exports = __webpack_public_path__ + "img/WP23-volunteers4.1119a380.jpg";